import { render, staticRenderFns } from "./Attestation.vue?vue&type=template&id=898f5d92&"
import script from "./Attestation.vue?vue&type=script&lang=js&"
export * from "./Attestation.vue?vue&type=script&lang=js&"
import style0 from "./Attestation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports